import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AnalyticsSettingsComponent} from './analytics-settings.component';
import {ArmFormModule} from '../../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../../material.module';



@NgModule({
  declarations: [AnalyticsSettingsComponent],
  imports: [
    CommonModule,
    ArmFormModule,
    ArmFormTitleModule,
    FormsModule,
    MaterialModule
  ]
})
export class AnalyticsSettingsModule { }
